<template>
  <section>
    <modal :title="title" :show="showModal" @close="closeModal()">
      <div class="content" slot="content">
        <validation-observer ref="form">
        <form>
          <div class="margin-top-l">
            <validation-provider
              name="nome"
              rules="required"
              v-slot="{ errors }"
            >
              <div
                class="form-field item group-input "
                :class="{ errors: errors[0] }"
              >
                Nome
                <input
                  type="text"
                  v-model="cf.name_key"
                  placeholder="Nome do campo personalizado"
                />
                <span class="erros-alert">{{ errors[0] }}</span>
              </div>
            </validation-provider>
            <!-- template -->
            <div v-if="cf" class="flex column margin-top-m">
              <div class="flex-1 w100">
                <div class="form-field item group-input ">
                  Tipo
                  <select
                    class="input"
                    v-model="cf.custom_type"
                    :disabled="isEdit"
                  >
                    <option
                      v-for="(v, k) in typeList"
                      :key="k"
                      :value="v.id"
                    >
                      {{ v.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </form>
      </validation-observer>
      </div>
      <div class="action" slot="action">
        <div class="flex center">
          <button @click="closeModal()" class="button secondary medium">
            Voltar
          </button>
          <button
            type="submit"
            @click="acceptModal()"
            class="button primary medium"
            :class="{ unusual: unusual == 'accept' }"
          >
            {{ isEdit ? "Editar" : "Criar" }}
          </button>
        </div>
      </div>
    </modal>
  </section>
</template>

<script>
import Modal from "@/components/modal/Modal";

export default {
  name: "modal-new-custom-field",
  props: {
    titleName: {
      required: false,
      default: "Criar Campo Personalizado",
    },
    show: {
      required: true,
      default: false,
    },
    unusual: {
      required: false,
      default: "false",
    },
    cf: {
      required: true,
      default: Object,
    },
  },
  components: {
    Modal,
  },
  data() {
    return {
      showDeleteModal: false,
      selectModalDelete: null,
      showModal: false,
      seenGuide: {},
      title: "Criar Campo Personalizado",
      typeList: [
        { id: 'STRING', label: 'TEXTO' },
        { id: 'NUMBER', label: 'NUMERO' },
        { id: 'FLOAT', label: 'DINHEIRO' },
      ]
    };
  },
  watch: {
    show(value) {
      this.showModal = value;
    },
  },
  updated() {
    if (this.isEdit) {
      this.title = 'Editar Campo Personalizado'
    }
  },
  mounted() {
    if (this.isEdit) {
      this.title = 'Editar Campo Personalizado'
    }
  },
  computed: {
    isEdit() {
      return this.cf && this.cf.id;
    },
  },
  methods: {
    acceptModal() {
      this.showModal = false;
      this.$emit("accept", this.cf);
    },
    closeModal() {
      this.showModal = false;
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.action {
  margin-top: 30px;
  .button {
    margin-left: 10px !important;
  }
}

textarea {
  border-radius: 5px;
  border: 1px solid #3333;
  padding: 15px;
  max-width: 500px;
  min-width: 500px;
  min-height: 150px;
  max-height: 150px;
}

ul {
  list-style: none;
  max-height: 200px;
  overflow-y: scroll;
  li {
    padding: 4px 8px;
    border-bottom: 1px solid #ccc;
    .tag {
      background: #c2c2c2;
      padding: 4px 6px;
      border-radius: 5px;
      font-size: 11px;
      font-weight: 800;
      margin-left: 8px;
    }
    .button {
      margin-left: 4px;
      padding: 4px 6px;
    }
  }
}
</style>
